import { ManagerActionTypes, ManagerActionUnion } from './actions';
import { DealVersion } from '../../types/deal.types';
import { ManagerState } from './state';
import { ManagerGridColumnName } from '../../grid/types/column.types';
import { SortOrder } from '../../grid/types/sorting.types';
import { ManagerSelectionActionTypes } from './selection/actions';

export const initialManagerState: ManagerState = {
  deals: undefined,
  loading: false,
  loaded: false,
  isActive: false,
  error: undefined,
  sortModel: [
    {
      colId: ManagerGridColumnName.Size,
      sort: SortOrder.Desc
    }
  ],
  selectedDeals: [],
  viewType: 'twoThirdGrid', //initial view type,
  dealsDetails: {}
};

export function managerReducer(
  state: ManagerState = initialManagerState,
  action: ManagerActionUnion
): ManagerState {
  let newDealsSelection;
  switch (action.type) {
    case ManagerActionTypes.LoadManager:
      // eslint-disable-next-line no-case-declarations
      const showLoading = action.showLoading || state.deals === undefined;

      return {
        ...state,
        loading: showLoading
      };
    case ManagerActionTypes.LoadManagerSuccess:
      // eslint-disable-next-line no-case-declarations
      const { data } = action.payload;

      return {
        ...state,
        deals: data,
        loading: false,
        loaded: true,
        error: undefined
      };
    case ManagerActionTypes.LoadManagerFail:
      return {
        ...state,
        deals: undefined,
        loading: false,
        loaded: false,
        error: action.error
      };
    case ManagerActionTypes.RemoveManagerDeals:
      return {
        ...state,
        deals:
          state.deals &&
          state.deals
            .slice(0)
            .filter((deal) => action.dealIds.indexOf(deal.id) === -1)
      };
    case ManagerActionTypes.TaintManager:
      return {
        ...state,
        deals: undefined,
        loading: false,
        loaded: false,
        error: undefined
      };
    case ManagerActionTypes.ManagerIsActive:
      return {
        ...state,
        isActive: action.isActive
      };
    case ManagerActionTypes.ManagerSetSortModel:
      return {
        ...state,
        sortModel: action.sortModel
      };
    case ManagerSelectionActionTypes.ManagerDealSelection:
      if (action.selected) {
        newDealsSelection = [...state.selectedDeals];
        if (!state.selectedDeals.includes(action.dealId)) {
          newDealsSelection.push(action.dealId);
        }
      } else {
        newDealsSelection = state.selectedDeals.filter(
          (dealId) => dealId !== action.dealId
        );
      }

      return {
        ...state,
        selectedDeals: newDealsSelection
      };
    case ManagerSelectionActionTypes.ManagerDealSelectionMany:
      newDealsSelection = action.dealsSelection
        .filter((ea) => ea.selected)
        .map((ea) => ea.dealId);

      return {
        ...state,
        selectedDeals: newDealsSelection
      };
    case ManagerSelectionActionTypes.ManagerDealsSelectionChanged:
      return {
        ...state,
        selectedDeals: generateResultSelection(
          state.selectedDeals,
          action.dealIds
        )
      };
    case ManagerActionTypes.ManagerViewTypeChanged:
      return {
        ...state,
        viewType: action.viewType
      };
    case ManagerActionTypes.ManagerLoadDealDetailsSuccess:
      return {
        ...state,
        dealsDetails: {
          ...state.dealsDetails,
          [action.payload.dealId]: {
            deal: action.payload.dealDetails,
            orders: action.payload.orders,
            error: undefined
          }
        }
      };
    case ManagerActionTypes.ManagerLoadDealDetailsFailed:
      return {
        ...state,
        dealsDetails: {
          ...state.dealsDetails,
          [action.payload.dealId]: {
            deal: undefined,
            orders: undefined,
            error: action.payload.error
          }
        }
      };
    default:
      return state;
  }
}

function generateResultSelection(
  prevSelection: string[],
  newSelection: string[]
): string[] {
  const result = new Set([
    ...(prevSelection ? prevSelection : []),
    ...(newSelection ? newSelection : [])
  ]);
  return [...result];
}

export const getManagerDeals = (state: ManagerState): DealVersion[] =>
  state.deals;

export const selectManagerLoading = (state: ManagerState) => state.loading;

export const selectManagerLoaded = (state: ManagerState) => state.loaded;

export const selectManagerError = (state: ManagerState) => state.error;

export const selectManagerStatus = (state: ManagerState) => state.isActive;

export const selectManagerSortModel = (state: ManagerState) => state.sortModel;

export const selectManagerSelectionModel = (state: ManagerState) =>
  state.selectedDeals;

export const selectManagerViewType = (state: ManagerState) => state.viewType;
